export default class AccessToken {
  public static get(): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const val = localStorage.getItem(AccessToken.KEY);
      resolve(val);
    });
  }

  public static set(value: string): Promise<void> {
    return new Promise(resolve => {
      localStorage.setItem(AccessToken.KEY, value);
      resolve();
    });
  }

  public static remove(): Promise<void> {
    return new Promise(resolve => {
      localStorage.removeItem(AccessToken.KEY);
      resolve();
    });
  }

  private static KEY = 'id_token';
}
